import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle2, Send, Phone, MessageCircle, Gem, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { useContent } from "../context/ContentContext";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { footer, telegramLink } = useContent();
  const order = location.state?.order;
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const t = setTimeout(() => setShow(true), 100);
    return () => clearTimeout(t);
  }, []);

  const cur = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
  const total = order?.amounts?.total;
  const paid = order?.payment?.status === "paid";
  const phone = footer?.phone || "9399993389";
  const whatsapp = footer?.whatsapp || "919399993389";

  return (
    <div className="min-h-screen bg-[#FBF5E9] flex flex-col items-center px-4 py-12">
      <div className={`w-full max-w-2xl bg-white rounded-2xl border border-[#e7d9b8] shadow-xl overflow-hidden transition-all duration-700 ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="bg-[#5A0B1D] px-6 py-10 text-center">
          <div className="mx-auto mb-4 w-20 h-20 rounded-full bg-[#C9992B] flex items-center justify-center float-y">
            <CheckCircle2 className="w-11 h-11 text-white" />
          </div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#F4E3B8]">{paid ? "Payment Received!" : "Your Order Is Confirmed!"}</h1>
          <p className="text-[#e9d7c0] mt-2 font-marcellus">Guruji's blessings are on the way to you.</p>
        </div>

        <div className="p-6 sm:p-8">
          {order ? (
            <div className="rounded-xl border border-[#e7d9b8] bg-[#FBF5E9] p-5 mb-6">
              <div className="flex items-center gap-2 text-[#5A0B1D] font-semibold mb-3"><Gem className="w-5 h-5 text-[#C9992B]" /> Order Summary</div>
              <div className="space-y-1.5 text-sm text-[#3a2a20]">
                <Row k="Order Reference" v={order.order_ref} strong />
                {(order.items || []).map((it, i) => (
                  <Row key={i} k={`${it.name}${it.variant_label ? " · " + it.variant_label : ""} × ${it.quantity}`} v={cur(it.line_total)} />
                ))}
                <Row k="GST" v={cur(order.amounts?.tax)} />
                <Row k="Payment" v={`${(order.payment?.method || "cod").toUpperCase()} · ${(order.payment?.status || "pending").toUpperCase()}`} />
                <Row k="Total" v={cur(total)} strong />
              </div>
            </div>
          ) : (
            <p className="text-center text-[#6b5647] mb-6">Thank you for your order. Our team will call you shortly to confirm the details.</p>
          )}

          <div className="rounded-xl border-2 border-[#229ED9]/30 bg-[#229ED9]/5 p-5 text-center mb-5">
            <Send className="w-8 h-8 text-[#229ED9] mx-auto mb-2" />
            <h3 className="font-display text-lg font-bold text-[#0e3a52]">Join Our Private Telegram Community</h3>
            <p className="text-sm text-[#3a2a20] mt-1 mb-4">Get daily wealth sadhana, secret mantras, wearing guidance and direct support from Guruji's team.</p>
            <a href={telegramLink} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#229ED9] hover:bg-[#1b87ba] text-white font-semibold px-7 h-12 rounded-full"><Send className="w-4 h-4 mr-2" /> Join Telegram Community</Button>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex-1">
              <Button variant="outline" className="w-full h-11 border-[#25D366] text-[#128C7E] hover:bg-[#25D366]/10"><MessageCircle className="w-4 h-4 mr-2" /> WhatsApp Us</Button>
            </a>
            <a href={`tel:+${whatsapp}`} className="flex-1">
              <Button variant="outline" className="w-full h-11 border-[#5A0B1D] text-[#5A0B1D] hover:bg-[#5A0B1D]/10"><Phone className="w-4 h-4 mr-2" /> Call {phone}</Button>
            </a>
          </div>

          <button onClick={() => navigate("/")} className="mt-6 mx-auto flex items-center gap-1 text-sm text-[#8a6d2f] hover:text-[#5A0B1D] font-medium">
            Back to Home <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

const Row = ({ k, v, strong }) => (
  <div className="flex justify-between gap-4">
    <span className="text-[#6b5647]">{k}</span>
    <span className={strong ? "font-bold text-[#5A0B1D]" : "font-medium"}>{v}</span>
  </div>
);

export default ThankYou;
